import { Injectable } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ActionSheetService {
  constructor(
    private readonly actionSheetCtrl: ActionSheetController,
    private readonly translate: TranslateService,
  ) {}

  async presentActionSheet(message: string, action: () => void) {
    const sheet = await this.actionSheetCtrl.create({
      header: this.translate.instant(message),
      buttons: [
        {
          text: this.translate.instant('movacarfleet_action_sheet_confirm'),
          data: true,
        },
        {
          text: this.translate.instant('movacarfleet_action_sheet_cancel'),
          role: 'cancel',
          data: false,
        },
      ],
    });

    await sheet.present();

    const detail = await sheet.onDidDismiss();

    if (detail.data) {
      action();
    }
  }
}
